import * as yup from "yup";
import { nameof } from "core/util/nameof";
export const Validate = () => {
    const schema = yup
        .object({
        Username: yup.string().required(),
        ResetMethod: yup.string().required(),
        TwoFactorToken: yup.string(),
        clientMutationId: yup.string(),
        ContactDetails: yup
            .string()
            .required("Can not be blank")
            .when(nameof("ResetMethod"), (resetMethod, schema) => {
            if (resetMethod === "email") {
                return schema
                    .required("Email can not be blank")
                    .email("Email is not valid");
            }
            if (resetMethod === "sms") {
                return schema
                    .required("Mobile number can not be blank")
                    .min(4, "Mobile number must be at least 4 digits");
            }
            return schema;
        }),
    })
        .defined();
    return schema;
};
